import React from "react";
import '../style.css';
import { TodoContext } from '../TodoContext';
import { langContext } from '../TodoContext/langContext';
import { FormattedMessage } from 'react-intl';

function TodoCounter() {
    const {totalTodos, completedTodos} = React.useContext(TodoContext);
    const language = React.useContext(langContext);

    return (
        <header>
          <h3><FormattedMessage id="header.h3" defaultMessage="Today"/></h3>
          <div className="task-indicators">
            <span>{completedTodos}</span>
            <span><i className="fa fa-check"></i>{totalTodos}</span>
          </div>
          <select name="languages" onChange={()=> language.setLanguage(document.getElementsByName("languages")[0].value)}>
              <option value="es"><FormattedMessage id="app.lang" defaultMessage="Languages"/></option>
              <option value="en-US">English</option>
              <option value="es">Español</option>
            </select>
        </header>
    );
}

export { TodoCounter };